import React, { useState } from "react";
import { FaEye, FaEyeSlash, FaLinkedin, FaYoutube, FaInstagram } from "react-icons/fa6";
import { CiUser, CiLock, CiCircleAlert } from "react-icons/ci";
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading, setUserName, setUserRole, setUserId } from '../redux/actions';
import Spinner from 'react-bootstrap/Spinner';
import api from '../common/api.js';
import SocialMedia from './SocialMedia.js';
import LoginQuotesPanel from './LoginQuotesPanel';
import useTenantAssets from "../common/useTenantLogo.js";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const { getLogo } = useTenantAssets();
  const [loginData, setLoginData] = useState({});
  const [errorMsg, setErrorMsg] = useState("");
  const [error, setError] = useState({});
  const navigate = useNavigate();
  const location = useLocation();
  let headline = "Login to Your account";
  if (location.state?.register) {
    headline = "Account created successfully! Please log in.";
  } else if (location.state?.fromReset) {
    headline = location.state.message || "Password changed successfully! Please log in with your new password.";
  }


  const loading = useSelector((state) => {
    return state.loading
  });
  const dispatch = useDispatch();

  const handleLogin = (e) => {
    e.preventDefault();
    setErrorMsg("");
    setError({});
    const data = {
      "email": loginData?.email,
      "password": loginData?.password,
    }
    console.log("Form data", data);

    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!loginData?.email || !loginData?.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(loginData?.email)) {
      newErrors.email = "Please enter a valid email address";
    }

    if (!loginData?.password || !loginData?.password.trim()) {
      newErrors.password = "Password is required";
    }

    if (Object.keys(newErrors).length > 0) {
      setError(newErrors);
      console.error("New error:", newErrors);
      return;
    }
    setError({});
    dispatch(setLoading(true));
    api.post("/login", data)
      .then((response) => {
        if (response.data?.active === true) {
          sessionStorage.setItem('token', response.data?.token);
          sessionStorage.setItem('name', response.data?.name);
          sessionStorage.setItem('userRole', response.data?.user_role);
          sessionStorage.setItem('userId', response.data?.user_id);
          if(response.data?.company_id) {
          sessionStorage.setItem('companyId', response.data?.company_id);
          }
          if (response.data?.stamping_partner_id) {
            sessionStorage.setItem('stampingPartnerId', response.data.stamping_partner_id);
          }
          dispatch(setUserName(sessionStorage.getItem('name')));
          dispatch(setUserRole(parseInt(sessionStorage.getItem('userRole'))));
          dispatch(setUserId(parseInt(sessionStorage.getItem('userId'))));
          dispatch(setLoading(false))
          navigate('/dashboard');
        } else {
          dispatch(setUserName(response.data?.name));
          navigate('/verification');
        }
      })
      .catch((err) => {
        dispatch(setLoading(false));
        if (err.response?.status === 401) {
          setErrorMsg("Invalid email or password");
        } else if (err.response?.status === 404) {
          setErrorMsg("User not registered");
        } else if (err.response?.status === 500) {
          setErrorMsg("Server Error. Please try again later");
        } else if (err.response?.data?.message) {
          setErrorMsg(err.response.data.message);
        } else {
          setErrorMsg("Something went wrong. Please try again.");
        }
      });
  };

  const handleRegister = () => {
    navigate('/register');
  };

  const handleDataChange = (field, value) => {
    let loginDataCopy = { ...loginData };
    loginDataCopy[field] = value;
    setLoginData(loginDataCopy);
    if (error[field]) {
      setError(prev => ({
        ...prev,
        [field]: ''
      }));
    }
    if (errorMsg) {
      setErrorMsg('');
    }
  }

  return (
    <div className="login-main">
    <LoginQuotesPanel />
      <div className="login-left">
        <div className="login-left-container">
          <div className="login-logo">
           <img src={getLogo("login")} alt="Login Logo" />
          </div>
          <div className="login-center">



            <h2>{headline}</h2>
            <form>


              {errorMsg && (
                <div className="d-flex justify-content-center mt-3">
                  <div className="alert alert-danger  d-flex align-items-center gap-2 px-4 py-2 rounded-3 shadow-sm text-center">
                    <CiCircleAlert size={20} />
                    <span className="fw-semibold">{errorMsg}</span>
                  </div>
                </div>
              )}




              <div className={`error-box ${error.email ? "input-error" : ""}`}>
                <CiUser className="input-icon" />
                <input
                  type="email"
                  placeholder="Enter Email address"
                  onChange={(e) => handleDataChange("email", e.target.value)} />

                {error.email && <span className="error-text">{error.email}</span>}
              </div>





              <div className="error-box-parent" >
                <div className={`error-box ${error.email ? "input-error" : ""}`}>
                  <CiLock className="input-icon" />
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter Password"
                    onChange={(e) => handleDataChange("password", e.target.value)} />


                  <span
                    className="toggle-password"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>


                  {error.password && <span className="error-text">{error.password}</span>}


                </div>

              </div>





              <div className="login-center-options">
                <div className="remember-div">
                  <input type="checkbox" id="remember-checkbox" />
                  <label htmlFor="remember-checkbox">
                    Remember me
                  </label>
                </div>
                <a href="forgotpassword" className="forgot-pass-link">
                  Forgot password?
                </a>
              </div>

              <div className="login-center-buttons">
                <button onClick={handleLogin} type="submit">
                  {!loading ? "Log in" : <Spinner animation="border" variant="info"  className="custom-spinner" />}
                </button>
              </div>

              {/* New User Section */}
              <div className="new-user-section">
                New user?{' '}
                <span onClick={handleRegister} className="create-account-link">
                  Create an account
                </span>
              </div>

            </form>
          </div>
          <SocialMedia />
        </div>
      </div>
  
    </div>

  );
};

export default Login;